import React from 'react';
import {Switch, Route} from "react-router-dom"
import Sec01Green from "./components/Sec01Green";
import Sec02NAV from "./components/Sec02NAV"
import Sec03BT from "./components/Sec03BT"
import Sec04Home from "./components/Sec04Home"
import Sec10LowerSearch from './components/Sec10LowerSearch'
import Sec11Footer from "./components/Sec11Footer"
import Sec12UnderFooter from "./components/Sec12UnderFooter"
import Aletler from "./components/Aletler"
import Alet from "./components/Alet"
import Guitars from "./components/Guitars"
import Pianos from "./components/Pianos"
import Violins from "./components/Violins"
import Drums from "./components/Drums"
import ForKids from "./components/ForKids"
import TermsOfUse from './components/TermsOfUse'
import FAQ from './components/FAQ';
import CustomerService from './components/CustomerService';
import AboutUs from './components/AboutUs';
import Cancellation from './components/Cancellation';
import Delivery from './components/Delivery';
import WishList from './components/WishList';
import Basket from './components/Basket';
import Register from './components/Register';
// import { useEffect } from 'react';

function App() {
//   useEffect(()=>{
//   const getData=async()=>{
//     let data = await fetch("http://192.168.1.103/aletler.json").then(a=>a.json());
//     console.log(data);
//   }
//     getData();
//   })
//   let oo={
//     id:null,
//     alet_novu: "GUITARS",
//     marka: "YAMAHA",
//     model: "PACIFICA 012 BL",
//     img: "https://www.muztorg.ru/files/7so/by1/lj2/hwk/wgw/wc8/kkc/gco/k/7soby1lj2hwkwgwwc8kkcgcok.jpg",
//     price: "269.99",
//     description: "adasdasda 1111",
//     wishstate: false,
//     cartstate: false,
//     liked: "",
//     carted_text: "Add to basket",
//     carted_style: "",
//     newOrNot: "New"
//   };
//   const funksiya = () => {
//     oo.id = Math.floor(Math.random() * 7485161);
//   fetch("http://192.168.1.103/additem.php", {
//     method: "POST", 
//     body: JSON.stringify(oo), 
//   }).then(a=>a.json()).then(a=>console.log(a));
// }
  return (
    <div className="App">
    {/* <button onClick={funksiya}>Salam</button> */}
      <Sec01Green />
      <Sec02NAV />
      <Sec03BT />
      <Switch>
        <Route exact path="/">
          <Sec04Home />
        </Route>
        <Route path="/guitars">
          <Guitars />
        </Route>
        <Route path="/pianos">
          <Pianos />
        </Route>
        <Route path="/violins">
          <Violins />
        </Route>
        <Route path="/drums">
          <Drums />
        </Route>
        <Route path="/forkids">
          <ForKids />
        </Route>
        <Route exact path="/all_instruments">
          <Aletler />
        </Route>
        <Route path="/all_instruments/:aletId">
          <Alet />
        </Route>
        <Route path="/terms_of_use">
          <TermsOfUse />
        </Route>
        <Route path="/faq">
          <FAQ />
        </Route>
        <Route path="/customer_service">
          <CustomerService />
        </Route>
        <Route path="/about_us">
          <AboutUs />
        </Route>
        <Route path="/cancellation_of_the_order">
          <Cancellation />
        </Route>
        <Route path="/delivery">
          <Delivery />
        </Route>
        <Route path="/wishlist">
          <WishList />
        </Route>
        <Route path="/basket">
          <Basket />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
      </Switch>
      <Sec10LowerSearch />
      <Sec11Footer />
      <Sec12UnderFooter />
    </div>
  );
};

export default App;